import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAccessLogSlice } from './get';

import { coreDataSecurityAccessLogExportReducers, coreDataSecurityAccessLogExportWatchers } from './export';

export const coreDataSecurityAccessLogReducers = combineReducers({
	export: coreDataSecurityAccessLogExportReducers,
	get: getCoreDataSecurityAccessLogSlice.asyncReducers
});

export const coreDataSecurityAccessLogWatchers = combineAllWatchers([
	coreDataSecurityAccessLogExportWatchers,
	getCoreDataSecurityAccessLogSlice.asyncWatchers
]);
